import React from "react";
import { fmtDate } from "@/lib/constants";

/** Field-level revision history table. */
export default function LeadRevisions({ revisions }) {
  return (
    <div className="brut-card mt-4 p-5">
      <div className="font-chivo font-bold uppercase tracking-tight mb-4">Field-level edit history</div>
      <table className="w-full text-sm font-mono">
        <thead>
          <tr className="border-b border-black text-[10px] uppercase tracking-widest">
            <th className="py-2 text-left">When</th>
            <th className="py-2 text-left">Field</th>
            <th className="py-2 text-left">From</th>
            <th className="py-2 text-left">To</th>
            <th className="py-2 text-left">By</th>
            <th className="py-2 text-left">Reason</th>
            <th className="py-2 text-left">Shared</th>
          </tr>
        </thead>
        <tbody>
          {revisions.map((r) => (
            <tr key={r.id} className="border-b border-zinc-200">
              <td className="py-1 text-[11px]">{fmtDate(r.created_at)}</td>
              <td className="py-1">{r.field}</td>
              <td className="py-1 text-zinc-600">{String(r.old_value ?? "—")}</td>
              <td className="py-1">{String(r.new_value ?? "—")}</td>
              <td className="py-1">{r.changed_by_name || r.changed_by?.slice(0, 8)}</td>
              <td className="py-1">{r.reason || "—"}</td>
              <td className="py-1">
                {[r.share_with_client && "client", r.share_with_affiliate && "affiliate"]
                  .filter(Boolean).join("+") || "—"}
              </td>
            </tr>
          ))}
          {!revisions.length && (
            <tr><td colSpan={7} className="py-6 text-center label-mono">No edits yet</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
